/**
 * Tabs Component - Controller
 * =============================
 */

import type { INgModelController } from 'angular';
import { BASE_CLASSES, TabsOption } from './constants';

export interface TabsBindings {
  options?: TabsOption[];
  onChange?: (args: { value: string }) => void;
}

export class TabsController implements TabsBindings {
  ngModelCtrl?: INgModelController | null;

  // Bindings
  options?: TabsOption[];
  onChange?: (args: { value: string }) => void;

  // Estado interno
  selectedValue = '';

  $onInit(): void {
    this.options = this.options || [];
    if (this.ngModelCtrl) {
      // ⚠️ BRIDGE (leer) — value-based: viewValue === value seleccionado.
      this.ngModelCtrl.$render = () => {
        this.selectedValue = (this.ngModelCtrl && (this.ngModelCtrl.$viewValue as string)) || '';
      };
    }
  }

  $onDestroy(): void {
    this.ngModelCtrl = null;
  }

  handleSelect(value: string): void {
    this.selectedValue = value;
    // ⚠️ BRIDGE (escribir) — value-based: setViewValue(value).
    if (this.ngModelCtrl) {
      this.ngModelCtrl.$setViewValue(value);
    }
    if (typeof this.onChange === 'function') {
      this.onChange({ value });
    }
  }

  // ---- Clases ----

  getContainerClasses(): string[] {
    return [BASE_CLASSES.container];
  }

  getOptionClasses(option: TabsOption): string[] {
    const isSelected = option.value === this.selectedValue;
    return [BASE_CLASSES.option, isSelected ? BASE_CLASSES.selected : BASE_CLASSES.unselected];
  }
}

export default TabsController;
